import { render, staticRenderFns } from "./PermissionFolderPerson.vue?vue&type=template&id=7d4b5899"
import script from "./PermissionFolderPerson.vue?vue&type=script&lang=js"
export * from "./PermissionFolderPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports